// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2YhOQ","col":"styles_col__3z0vT","fulfillmentStatus":"styles_fulfillmentStatus__2LhCU","emailCol":"styles_emailCol__AxBG9"};